import { IAnalysisItem } from "./IAnalysisItem";

export interface IProcessReportsResult {
    allReports: IAnalysisItem[];
    unviewedReportCount: number;
    uniqueReportTypes: string[];
}
